export const AppImagePreview = ({ fileName, srcUrl }: { fileName?: string, srcUrl?: string; }) => {
    return (
        <div style={{ marginBottom: '1rem' }}>
            <img src={srcUrl} alt={fileName} style={{ maxWidth: '100%' }} />
        </div>
    );
};

export default AppImagePreview;